import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../../providers/auth";
import { cn } from "../../../util/cn";
import { ExternalDashboardChildRoutes_NewUI } from "../../../react-router_routes/external/childrenRoutes";
import { customDataRouteObject } from "../../../dataTypes/ReactRouter";
import { useEmployer } from "../../../data/employer";
import ExclamationSVG from "../../custom-ui/icons/ExclamationSVG";

const options = ExternalDashboardChildRoutes_NewUI;

function SidebarWrapper_NewUI({ children }: { children: any }) {
  const { role, user } = useAuth();
  const { data: employer } = useEmployer(user?.claims?.employerId || "");

  const optionRoutes = useMemo(() => {
    if (!role?.id) return [];
    return options.filter((option: any) => option.viewer.includes(role.id));
  }, [role?.id]);

  return (
    <div className="absolute left-0 w-full min-h-screen overflow-hidden flex flex-row">
      <div className="relative left-0 min-h-screen overflow-hidden bg-gray-50 w-[16%] min-w-[340px]">
        <div
          id="tabmenu"
          className="relative ml-[30px] mt-[103px] mb-[30px] bg-[white] text-[#15415E] font-medium pt-8 pb-36  h-[calc(100vh-15%)] overflow-y-auto overflow-x-hidden no-scrollbar rounded-[14px]"
        >
          <div>
            {optionRoutes.map(
              (pageObj: customDataRouteObject) => {
                const { svgIcon: SvgIcon } = pageObj;

                return (
                  <div key={pageObj.id}>
                    {pageObj.viewer !== undefined &&
                      pageObj.viewer.includes(role.id) &&
                      pageObj.menuDisplay && (
                        <div className="w-full text-[20px] leading-[24.76px]">
                          <NavLink
                            id={pageObj.id}
                            key={pageObj.id}
                            to={pageObj.path}
                            className={({
                              isActive,
                            }: {
                              isActive: boolean;
                            }) => {
                              return cn(
                                "flex flex-row gap-[10px] mb-[20px] py-4 pl-6 text-left items-center",
                                {
                                  "bg-[white] text-[#15415E] border-l-4 border-[#15415E] font-bold":
                                    isActive,
                                  " text-instant-teams-blue-Main  hover:bg-gray-50 hover:border-l-4 opacity-[80%] hover:border-[#9db4d2]":
                                    !isActive,
                                },
                              );
                            }}
                          >
                            {(pageObj.id === "Billing Information" && (!employer?.billingContact)) ? <ExclamationSVG sizeSmall={true} className="text-[#ED3535]" /> : ""}
                            {(pageObj.id === "Billing Information" && (!employer?.billingContact)) ? null : SvgIcon}
                            {pageObj.name}
                          </NavLink>
                        </div>
                      )}
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
      <div className="relative w-[84%] overflow-hidden">
        <div className="mt-[73px] h-[calc(100vh-73px)] overflow-auto w-full bg-gray-50 mb-0 pt-24 p-10">
          {children}
        </div>
      </div>
    </div>
  );
}

export default SidebarWrapper_NewUI;
